import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Label } from "@/components/ui/label";

/**
 * A chi e' affidato il mezzo: il dipendente che lo usa abitualmente.
 * Compare solo per le categorie in cui ha senso (vetture e furgoni attrezzati);
 * per le altre la scheda resta com'e'.
 */
export const CATEGORIE_CON_UTILIZZATORE = ["AUTOVETTURE", "FURGONI ATTREZZATI"];

export const haUtilizzatore = (categoria) => CATEGORIE_CON_UTILIZZATORE.includes(categoria);

export default function CampoUtilizzatore({ categoria, value, onChange }) {
  const [dipendenti, setDipendenti] = useState(null);
  const mostra = haUtilizzatore(categoria);
  useEffect(() => {
    if (!mostra || dipendenti) return;
    api.get("/employees").then(({ data }) => setDipendenti(data)).catch(() => setDipendenti([]));
  }, [mostra, dipendenti]);
  if (!mostra) return null;
  return (
    <div>
      <Label>Utilizzatore</Label>
      <select className="w-full h-10 border border-slate-200 rounded px-3" value={value || ""}
              onChange={(e) => onChange(e.target.value || null)} data-testid="eq-utilizzatore">
        <option value="">— nessuno —</option>
        {(dipendenti || []).map(d => <option key={d.id} value={d.id}>{d.full_name}</option>)}
      </select>
      <p className="text-xs text-slate-500 mt-1">Il dipendente a cui è affidato il mezzo.</p>
    </div>
  );
}
